import React, { useCallback } from 'react'
import { FormattedMessage } from 'react-intl'
import LineUserIcon from 'LuxKit/Icons/line/LineUserIcon'
import TextLink from 'LuxKit/TextLink'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import { generateOfferPageRoom, OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import MessageBanner from 'LuxKit/Banners/MessageBanner'

function TravellingSoloBanner() {
  const offerPageDispatch = useOfferPageDispatch()

  const handleViewSoloPackages = useCallback((e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    offerPageDispatch({
      type: OfferPageActions.setRooms,
      rooms: [generateOfferPageRoom({ adults: 1, children: 0, infants: 0 })],
    })
  }, [offerPageDispatch])

  return (
    <MessageBanner
      kind="promotional-primary"
      icon={<LineUserIcon />}
    >
      <FormattedMessage
        id="0yDsF8LnS6"
        defaultMessage="<strong>Travelling solo?</strong> — Unlock special rates and tailored inclusions. "
        description="Promotional banner text encouraging solo travellers to view special rates"
        values={{ strong: (chunks: React.ReactNode) => <strong>{chunks}</strong> }}
      />
      <TextLink underline weight="regular" onClick={handleViewSoloPackages}>
        <FormattedMessage
          id="dYpu+eYu3g"
          defaultMessage="View packages"
          description="Link text to view solo traveller packages"
        />
      </TextLink>
    </MessageBanner>
  )
}

export default React.memo(TravellingSoloBanner)
